var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", class: _vm.borderCheck },
    [
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _vm.heading
            ? _c("h3", {
                staticClass: "title is-4 has-text-weight-bold",
                domProps: { textContent: _vm._s(_vm.heading) },
              })
            : _vm._e(),
        ]),
        _c("div", { staticClass: "level-right" }, [
          _vm.tableData && _vm.exceldownload
            ? _c(
                "a",
                {
                  staticClass: "button is-small gtm-download-excel level-item",
                  attrs: {
                    disabled: !_vm.canDownload,
                    href: _vm.exceldownload.link,
                    target: "_blank",
                  },
                },
                [
                  _c("dc-icon", { attrs: { icon: "download" } }),
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.exceldownload.label) },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.tableData && _vm.csvdownload
            ? _c(
                "button",
                {
                  staticClass: "button is-small gtm-download-csv level-item",
                  attrs: { disabled: !_vm.canDownload },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadableCSV.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("dc-icon", { attrs: { icon: "download" } }),
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.csvdownload.label) },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm.rows && _vm.rows.length > 0
        ? _c(
            "b-table",
            {
              attrs: {
                data: _vm.rows,
                columns: _vm.columns,
                paginated: _vm.isPaginated,
                "per-page": _vm.perPage,
                loading: _vm.isFetching,
                "default-sort": _vm.defaultSort,
              },
            },
            [
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [_c("p", [_vm._v(_vm._s(_vm.errorMessage))])]
                  ),
                ]),
              ]),
            ],
            2
          )
        : _c("span", [_vm._v(" There is no data to display ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }